/*
 * The canvas the frame sits on (the mockup's `.pv-stage`): dotted, padded, the frame centred. The
 * stage scrolls when the frame is wider than the space; the frame never shrinks to fit.
 */
.stage {
  --preview-height: max(480px, calc(100vh - 160px));
  --preview-width: 1280px;
  --preview-zoom: 1;

  display: flex;
  flex: 1 1 auto;
  justify-content: safe center;
  min-block-size: 0;
  padding: var(--space-6);
  overflow: auto;
  background-image: radial-gradient(var(--canvas-dot) 1px, transparent 1px);
  background-size: 16px 16px;
}

/* The on-screen size of the frame, so the scroll extent follows the zoom. */
.sizer {
  flex: none;
  width: calc(var(--preview-width) * var(--preview-zoom));
  height: calc(var(--preview-height) * var(--preview-zoom));
  overflow: hidden;
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  background: var(--surface-raised);
}

.scaler {
  width: var(--preview-width);
  height: var(--preview-height);
  transform-origin: top left;
}

/* Present only when the zoom is not 1: a width change alone never carries a transform. */
.scaler[data-scaled="true"] {
  transform: scale(var(--preview-zoom));
}

/* The stage is reachable by keyboard (it scrolls): the ring sits inside, where no scroller clips it. */
.stage:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}
